import { z } from 'zod'

/** 城市 Schema */
export const citySchema = z.object({
  /** 區域代碼 */
  areaCode: z.string(),
  /** 國家代碼 */
  countryCode: z.string(),
  /** 城市編號 */
  cityId: z.string(),
  /** 名稱 */
  name: z.string(),
  /** 是否有效 */
  enable: z.boolean()
})

/** 城市 */
export interface City extends z.infer<typeof citySchema> {}
